module.exports = __webpack_public_path__ + "img/category__2.432565cd.svg";